<template>
  <div class="f-v f-ast">
    <div class="f m-bx4">
      <lucide-icon :name="data.icon" class="purple" :stroke-width="2" />
      <div class="t bold m-lx1">{{ data.copy }}</div>
    </div>

    <component :is="data.component" v-bind="data.props" />
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { useStore } from 'vuex';

  const { state } = useStore();

  const data = computed(() => state.modal.data);
</script>
